import resolveConfig from 'tailwindcss/resolveConfig';
import { default as tailwindConfig } from './../../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);
const tailwindsColors = fullConfig.theme.colors;
const tailwindsBreakpoints = fullConfig.theme.screens;

export { fullConfig, tailwindsBreakpoints, tailwindsColors };
